import stylesheet from './TabBar.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import {NXTTabBarItem} from "./TabBarItem";

class NXTTabBar extends CustomComponent {

    private selectedElement: NXTTabBarItem;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get defaultSlot() {
        return this.shadowRoot.querySelector('slot');
    }

    render() {
        const tabBarContainer = document.createElement('div');
        tabBarContainer.classList.add('full-content');
        tabBarContainer.innerHTML = `
            <div class="tab-container">
                <div class="tab-scroll-container">
                    <ul class="tab-bar">
                        <slot></slot>
                    </ul>
                </div>
            </div>
        `;
        const tabBar = tabBarContainer.querySelector('ul.tab-bar');
        tabBar.addEventListener('click', (event: PointerEvent) => this.handleItemSelectEvent(event))
        tabBar.querySelector('slot')
            .addEventListener('slotchange', () => {
            this.findSelectedOrDefault();
        });
        return tabBarContainer;
    }

    findSelectedOrDefault() {
        if(!this.defaultSlot) {
            return;
        }
        let items = this.defaultSlot.assignedElements()
            .filter(el => el instanceof NXTTabBarItem);
        const selectedElements = items.filter(el => el.hasAttribute('selected'));
        if (selectedElements.length > 0) {
            this.selectedElement = selectedElements[0];
        } else if (items.length > 0) {
            this.selectedElement = items[0];
        }
        this.handleItemSelect();
    }

    handleItemSelectEvent(event: PointerEvent) {
        if (event.target && event.target instanceof NXTTabBarItem) {
            this.selectedElement = event.target;
            this.handleItemSelect();
        }
    }

    private handleItemSelect() {
        if (!this.selectedElement || !this.defaultSlot) {
            return
        }
        this.defaultSlot.assignedElements()
            .forEach((el) => el.removeAttribute('selected'));
        this.selectedElement.setAttribute('selected', 'selected');
        this.dispatchEvent(
            new CustomEvent('tab-selected', {
                detail: {
                    selectedIndex: this.selectedIndex,
                    selectedElement: this.selectedElement,
                },
            })
        );
    }

    get selectedIndex() {
        return this.defaultSlot?.assignedElements()
            .indexOf(this.selectedElement) ?? 0;
    }

}

customElements.define('nxt-tab-bar', NXTTabBar);
